

// firebase-config.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: "newshutterlab.firebaseapp.com",
    databaseURL: "https://newshutterlab-default-rtdb.firebaseio.com",
    projectId: "newshutterlab", 
    storageBucket: "newshutterlab.firebasestorage.app",
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
    measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
};

let app, db, auth;

try {
    app = initializeApp(firebaseConfig);
    db = getFirestore(app);
    auth = getAuth(app);
} catch (error) {
    console.warn("Firebase initialization failed:", error);
    // Create fallback objects to prevent app crashes
    app = null;
    db = null;
    auth = null;
}

export { db, auth };

